import { render, staticRenderFns } from "./commonBtn.vue?vue&type=template&id=08378fde&scoped=true"
import script from "./commonBtn.vue?vue&type=script&lang=js"
export * from "./commonBtn.vue?vue&type=script&lang=js"
import style0 from "./commonBtn.vue?vue&type=style&index=0&id=08378fde&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08378fde",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/hybrid-app/ph-refusaldrainage-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08378fde')) {
      api.createRecord('08378fde', component.options)
    } else {
      api.reload('08378fde', component.options)
    }
    module.hot.accept("./commonBtn.vue?vue&type=template&id=08378fde&scoped=true", function () {
      api.rerender('08378fde', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/commonBtn.vue"
export default component.exports